import DHowInterpreting from './DHowInterpreting'

export default DHowInterpreting
